import React from 'react';

export const useMount = (callback: React.EffectCallback) => {
  React.useEffect(callback, []);
};
